document.addEventListener('DOMContentLoaded', function() {

    let collections = document.querySelector('#ProductGridContainer')
    if (collections) {
        let observer = new MutationObserver(  function(mutations) {
            mutations.forEach(async function(m) {
                if (m.addedNodes.length) {
                     const res = await BSS_B2B.storage.productStorage.load();
                    if (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size) {
                        await BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', {
                            ...res,
                        });
                    }

                }
            });
        });
        observer.observe(collections, {
            childList: true
        });
    }

    let quickAddDrawer = document.querySelector('#header-mini-cart-content')
    if (quickAddDrawer) {
        let observer = new MutationObserver(  function(mutations) {
            mutations.forEach(async function(m) {
                if (m.addedNodes.length) {
                    
                 BSS_B2B.observer.cartSubject.listenCartCheckout()
                 BSS_B2B.nt.initFunction()
                }
            });
        });
        observer.observe(quickAddDrawer, {
            childList: true
        });
    }
    let variantClick = document.querySelectorAll('[bss-b2b-variant-click]')
    if (variantClick.length) {
        variantClick.forEach(element => {
        element.addEventListener('click' , ()=>{
            let a = document.querySelector('.product-block-price [bss-b2b-product-id]')
            if (a) {
               a.style.visibility = "hidden";
            }
            setTimeout(() => {
                  if (a) {
               a.style.visibility = 'visible';
            }
                            const productForm = document.querySelector("[bss-b2b-product-form]");
                            BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
            }, 2000);

        })
    });
    } 

    setTimeout(() => {
  if (typeof BSS_B2B === 'object') {
    if (!window.location.href.includes('cart')) {
      BSS_B2B.nt.initFunction();
    } else {
      document.querySelector('#header-mini-cart-footer #bss-b2b-net-term-button')?.remove();
      BSS_B2B.nt.initFunction();
    }
  }
}, 2000);

});